// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"9b509765","193":"7b473323","228":"c0b3add4","356":"a73f53ac","450":"437aa8aa","694":"6bc3f5b1","787":"f4bfa4aa","806":"9559dfe7"}[chunkId] + ".chunk.js";
};